import { appConfiguration } from '../../configuration/appConfiguration';
import { User, UserManager } from 'oidc-client-ts';
import { useOidcUser } from './useOidcUser';
import { ExternalAuthSources } from '../../pages/RedirectPage';

const TOKEN_EXPIRATION_LEEWAY_SECONDS = 60;
const MOCKED_USER_SESSION_STORAGE_KEY = 'MOCK_EDENRED_USER';

const getMockedTokenExpiry = () => {
  const val = sessionStorage.getItem('EDENRED_TOKEN_EXPIRES_IN');
  return val !== null ? Number(val) : 7 * 24 * 60 * 60;
};

const mockEdenredUserManager: UserManager = (() => {
  // Cast to UserManager as we only implement class as far as needed in mock case
  return {
    getUser: async () => {
      const storedSessionData = sessionStorage.getItem(
        MOCKED_USER_SESSION_STORAGE_KEY,
      );
      return storedSessionData ? JSON.parse(storedSessionData) : null;
    },
    signinRedirect: async () => {
      window.open(
        `${window.location.origin}/redirect?source=${ExternalAuthSources.EDENRED}`,
        '_self',
      );
    },
    signinRedirectCallback: async () => {
      const mockUser = {
        access_token: 'local-edenred-mock-access-token',
        expires_in: getMockedTokenExpiry(),
        expired: false,
      } as User;

      sessionStorage.setItem(
        MOCKED_USER_SESSION_STORAGE_KEY,
        JSON.stringify(mockUser),
      );
      return mockUser;
    },
  } as UserManager;
})();

export const edenredUserManager: UserManager = appConfiguration
  .paymentCardProviderLogin.edenred.mock
  ? mockEdenredUserManager
  : new UserManager({
      authority: appConfiguration.paymentCardProviderLogin.edenred.authority!,
      client_id: appConfiguration.paymentCardProviderLogin.edenred.clientId!,
      client_secret:
        appConfiguration.paymentCardProviderLogin.edenred.clientSecret!,
      redirect_uri:
        appConfiguration.paymentCardProviderLogin.edenred.redirectUri!,
      response_type: 'code',
      scope: appConfiguration.paymentCardProviderLogin.edenred.scopes!,
      acr_values: appConfiguration.paymentCardProviderLogin.edenred.acr_values!,
      loadUserInfo: false,
    });

export const useEdenredToken = (): string | undefined => {
  const user = useOidcUser(edenredUserManager);

  if (
    user &&
    !user.expired &&
    (user.expires_in || 0) > TOKEN_EXPIRATION_LEEWAY_SECONDS
  ) {
    return user.access_token;
  }

  return undefined;
};
